import axios from "axios";

/** Service to get details/identifiers of Faculty */
export const getFacultyDetails = async (
  setFacultyDetails,
  setLoading,
  setAlert,
  clearAlert,
  universityId
) => {
  try {
    setLoading(true);
    clearAlert();
    const response = await axios({
      url: `/faculty/${universityId}`,
    });
    setFacultyDetails(response.data);
  } catch (error) {
    setAlert("error", error.message);
  } finally {
    setLoading(false);
  }
};

/** Service to get Appointments of Faculty */
export const getAppointmentsHistory = async (
  setAppointments,
  setLoading,
  setAlert,
  clearAlert,
  universityId
) => {
  try {
    setLoading(true);
    clearAlert();
    const response = await axios({
      url: `/faculty/${universityId}/appointments`,
    });
    if (response.data) {
      setAppointments(response.data);
    }
  } catch (error) {
    setAlert("error", error.message);
  } finally {
    setLoading(false);
  }
};

/** Service to get Leaves */
export const getLeaves = async (
  setLeaves,
  setLoading,
  setAlert,
  clearAlert,
  universityId
) => {
  try {
    setLoading(true);
    clearAlert();
    const response = await axios({
      url: `/faculty/${universityId}/leaves`,
    });
    if (response.data.leaves) {
      setLeaves(response.data.leaves);
    }
  } catch (error) {
    setAlert("error", error.message);
  } finally {
    setLoading(false);
  }
};

/** Service to get Appointment Segments */
export const getAppointmentSegments = async (
  setAppointmentSegments,
  setLoading,
  setAlert,
  clearAlert,
  universityId
) => {
  try {
    setLoading(true);
    clearAlert();
    const response = await axios({
      url: `/faculty/${universityId}/segments`,
    });
    if (response.data.segments) {
      setAppointmentSegments(response.data.segments);
    }
  } catch (error) {
    setAlert("error", error.message);
  } finally {
    setLoading(false);
  }
};

/** Service to get Accruals */
export const getAccruals = async (
  setAccruals,
  setAccrualsLoading,
  setAlert,
  clearAlert,
  universityId
) => {
  try {
    setAccrualsLoading(true);
    clearAlert();
    const response = await axios({
      url: `/faculty/${universityId}/accruals`,
    });
    if (response.data.accruedLeaves) {
      setAccruals(response.data.accruedLeaves);
    }
  } catch (error) {
    setAlert("error", error.message);
  } finally {
    setAccrualsLoading(false);
  }
};

/** Service to get Audit */
export const getAudit = async (
  setAuditDetails,
  setLoading,
  setAlert,
  clearAlert,
  universityId
) => {
  try {
    setLoading(true);
    clearAlert();
    const response = await axios({
      url: `/faculty/${universityId}/changehistory`,
    });
    if (response.data.changeHistory) {
      setAuditDetails(response.data.changeHistory);
    }
  } catch (error) {
    setAlert("error", error.message);
  } finally {
    setLoading(false);
  }
};
